import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {LocaleRestService} from '../../../shared/services/locale/locale-rest.service';
import {GlobalMessagesService} from '../../../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';
import {OrganizationSubType} from '../../../shared/types/organization/organization-type';
import {SecurityService} from '../../../shared/services/security/security.service';
import {Locale} from '../../../shared/types/localization/locale';
import {AddOrganizationSubtypeService} from '../../../shared/services/oganization/add-organization-subtype.service';

@Component({
  selector: 'wsd-add-organization-subtype',
  templateUrl: './add-organization-subtype.component.html',
  styleUrls: ['./add-organization-subtype.component.css']
})
export class AddOrganizationSubtypeComponent implements OnInit {

  @Output()
  onSave = new EventEmitter<any>();

  organizationSubtype: OrganizationSubType;

  languageItems: SelectItem[];
  selectedLocaleCode: string;

  organizationSubtypeForm: UntypedFormGroup;

  display: boolean = false;

  constructor(private addService: AddOrganizationSubtypeService,
              private localeRestService: LocaleRestService,
              private message: GlobalMessagesService,
              private translate: TranslateService,
              private securityService: SecurityService,
              private fb: UntypedFormBuilder) {
    this.organizationSubtypeForm = this.fb.group({
      parent: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.addService.messageSent$.subscribe(
      (organizationType: OrganizationSubType) => {
        this.organizationSubtype = organizationType;
        this.loadLanguages();
        this.organizationSubtypeForm.reset();
        this.organizationSubtypeForm.patchValue(organizationType);
        this.display = true;
      }
    );
  }

  loadLanguages() {
    this.localeRestService.getSupportedLanguages().subscribe(locales => {
      this.languageItems = locales.map(value => {
        return {
          label: value.name,
          value: value.code
        };
      });
      this.securityService.getCurrentLocale().subscribe((locale: Locale) => this.selectedLocaleCode = locale.code);
      this.initOrgTypeNames(locales);
    });
  }

  private initOrgTypeNames(locales) {
    if (!this.organizationSubtype.names) {
      this.organizationSubtype.names = [].concat(locales.map(locale => {
        return {langCode: locale.code};
      }));
    }
  }

  save() {
    this.fillEmptyNames();
    if (!!this.organizationSubtype.names.find(entry => !entry.value)) {
      this.message.showErrorMessage(this.translate.instant('WS_DIRECTORY.ORGANIZATION_SUBTYPE.FILL_ALL_NAMES'));
      return;
    }

    this.organizationSubtypeForm.markAsDirty();
    Object.keys(this.organizationSubtypeForm.controls).forEach(key => {
      this.organizationSubtypeForm.get(key).markAsDirty();
    });

    if (this.organizationSubtypeForm.invalid) {
      return;
    }

    this.organizationSubtype.parent = this.organizationSubtypeForm.get('parent').value;
    this.display = false;
    this.onSave.emit(this.organizationSubtype);
  }

  private fillEmptyNames() {
    this.organizationSubtype.names.forEach((name) => {
      name.value = name.value || this.organizationSubtype.names[0].value;
    });
  }

  discard() {
    this.display = false;
  }

}
